import React from 'react';
import { motion } from 'framer-motion';

const NauticalWaveOverlay: React.FC = () => {
  const draw = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: (i: number) => {
      const delay = 0.8 + i * 0.4;
      return {
        pathLength: 1,
        opacity: 0.03, // Very low opacity
        transition: {
          pathLength: { type: "spring", duration: 3, bounce: 0, delay },
          opacity: { duration: 0.01, delay }
        }
      };
    }
  };

  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none z-0">
      <motion.svg
        width="100%"
        height="100%"
        viewBox="0 0 1000 1000"
        initial="hidden"
        animate="visible"
        className="absolute inset-0"
        style={{
          transform: 'scale(1.5) rotate(5deg)', // Slightly larger and rotated for dynamic feel
          transformOrigin: 'center center',
          stroke: 'hsl(var(--gold))', // Subtle gold lines
          strokeWidth: '1',
          filter: 'drop-shadow(0 0 2px hsla(var(--gold)/0.02))',
        }}
      >
        {/* Abstract wave or contour lines */}
        <motion.path
          d="M 0,200 C 200,100 300,300 500,200 S 800,100 1000,200"
          fill="none"
          custom={0}
          variants={draw}
        />
        <motion.path
          d="M 0,400 C 200,300 300,500 500,400 S 800,300 1000,400"
          fill="none"
          custom={1}
          variants={draw}
        />
        <motion.path
          d="M 0,600 C 200,500 300,700 500,600 S 800,500 1000,600"
          fill="none"
          custom={2}
          variants={draw}
        />
        <motion.path
          d="M 0,800 C 200,700 300,900 500,800 S 800,700 1000,800"
          fill="none"
          custom={3}
          variants={draw}
        />
      </motion.svg>
    </div>
  );
};

export default NauticalWaveOverlay;